import React from 'react';
import { arrayOf, string, shape, number, bool, func } from 'prop-types';
import classnames from 'classnames';

import LineChart from 'ps-components/LineChart/LineChart';
import DisplayValueSwitcher from './DisplayValueSwitcher/DisplayValueSwitcher';

import './YearOverYearChart.scss';

class YearOverYearChart extends React.PureComponent {
  static propTypes = {
    className: string,
    xAxisLabels: arrayOf(string),
    seriesName: string,
    seriesDataValues: arrayOf(
      shape({
        name: string,
        y: number
      })
    ),
    showAsPercentage: bool,
    toggleAction: func
  };

  constructor(props) {
    super(props);

    this.toggleShowAsPercentage = this.toggleShowAsPercentage.bind(this);
  }

  // Returns the number of data points with non-null values
  getNumberOfDataPoints() {
    const { seriesDataValues } = this.props;

    let dataPoints = 0;
    for (let i = 0; i < seriesDataValues.length; i++) {
      if (seriesDataValues[i].y !== null) {
        dataPoints++;
      }
    }

    return dataPoints;
  }

  toggleShowAsPercentage() {
    this.props.toggleAction();
  }

  monetaryFormatter() {
    return Number(this.value).toLocaleString('en', {
      minimumFractionDigits: 0,
      maximumFractionDigits: 0
    });
  }

  percentFormatter() {
    return `${this.value}%`;
  }

  render() {
    const { xAxisLabels, className, seriesName, seriesDataValues, showAsPercentage = false } = this.props;

    const dataPoints = this.getNumberOfDataPoints();
    // If there are 1 or 0 data points, render the "not enough data" message in the
    // chart, which can be triggered by empty data
    const data = dataPoints > 1 ? seriesDataValues : [];
    const displayChartIn = showAsPercentage ? 'Percentage' : 'Monetary';

    const formatter = showAsPercentage ? this.percentFormatter : this.monetaryFormatter;

    const xAxisOptions = {
      lineColor: '#d3d3d3',
      tickLength: 0,
      title: {
        enabled: true,
        text: 'Benchmark Year'
      },
      categories: xAxisLabels,
      labels: {
        style: {
          color: '#666',
          fontSize: '14px'
        },
        reserveSpace: true
      },
      min: 0,
      max: 2
    };

    const yAxisOptions = {
      tickPixelInterval: 60,
      title: {
        enabled: false
      },
      labels: {
        style: {
          color: '#666',
          fontSize: '14px'
        },
        formatter
      }
    };

    const plotOptions = {
      column: {
        pointWidth: 60,
        pointPadding: 20,
        groupPadding: 0
      }
    };

    const seriesData = [
      {
        animation: true,
        cursor: 'pointer',
        name: seriesName,
        borderColor: '',
        label: {
          enabled: true
        },
        showInLegend: false,
        connectNulls: true,
        data
      }
    ];

    const classNames = classnames('year-over-year-chart', className);

    return (
      <div className="year-over-year-chart__container">
        <div className={classNames}>
          <div className="year-over-year-chart__chart-container">
            <LineChart
              width={545}
              height={200}
              xAxisOptions={xAxisOptions}
              yAxisOptions={yAxisOptions}
              plotOptions={plotOptions}
              seriesData={seriesData}
              noDataText="Insufficient data to display chart"
            />
          </div>
          {data.length > 1 && (
            <DisplayValueSwitcher displayChartIn={displayChartIn} handleOnChange={this.toggleShowAsPercentage} />
          )}
        </div>
      </div>
    );
  }
}

export default YearOverYearChart;
